import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dateDisplay"]

  connect() {
    this.containerSelector = this.data.get("containerSelector")
    this.itemSelector = this.data.get("itemSelector")
    this.timestampAttribute = "timestamp"

    if (!this.containerSelector || !this.itemSelector) {
      console.warn("Date Observer: Missing required selectors. Please provide container-selector and item-selector.")
      return
    }

    this.observer = null
    this.setupIntersectionObserver()
    this.setupMutationObserver()
  }

  setupMutationObserver() {
    const container = document.querySelector(this.containerSelector)
    if (!container) return

    const mutationObserver = new MutationObserver((mutations) => {
      let newItemFound = false

      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && 
                node.matches && node.matches(this.itemSelector) && 
                node.dataset[this.timestampAttribute]) {
              if (this.observer) {
                this.observer.observe(node)
                newItemFound = true

                const timestamp = node.dataset[this.timestampAttribute]
                if (timestamp) {
                  const itemDate = new Date(timestamp)
                  this.updateDateDisplay(itemDate)
                }
              }
            }
          })
        }
      })

      if (newItemFound && !this.observer) {
        this.setupIntersectionObserver()
      }
    })

    mutationObserver.observe(container, {
      childList: true,
      subtree: true
    })
  }

  setupIntersectionObserver() {
    const itemElements = document.querySelectorAll(`${this.itemSelector}[data-${this.timestampAttribute}]`)
    if (!itemElements.length) return

    const options = {
      root: document.querySelector(this.containerSelector),
      rootMargin: '0px',
      threshold: 0.5
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const timestamp = entry.target.dataset[this.timestampAttribute]
          if (timestamp) {
            const itemDate = new Date(timestamp)
            this.updateDateDisplay(itemDate)
          }
        }
      })
    }, options)

    itemElements.forEach(element => {
      this.observer.observe(element)
    })
  }

  updateDateDisplay(date) {
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })
    this.dateDisplayTarget.textContent = formattedDate
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}